import { ulid } from 'ulid';

import type { NewPlaylistItem, PlaylistItem } from '../types.js';
import { getContentTypeByUrl } from './get_content_type_by_url.js';
import { getFilenameFromUrl } from './get_filename_by_url.js';

export function getPlaylistItemWithDefaults<PlaylistItemMeta>(
  item: NewPlaylistItem<PlaylistItemMeta>,
): PlaylistItem<PlaylistItemMeta> {
  return {
    id: ulid(),
    name: item.url ? getFilenameFromUrl(item.url) : '',
    contentType: item.url ? getContentTypeByUrl(item.url) : 'unknown',
    frameRate: 0,
    ...item,
  };
}
